import { DateTime } from 'luxon';
import i18n from 'i18next';

const getFormat = () => {
  const fullDateTimeformat = i18n.language === 'en' ? 'EEEE, MMMM dd, yyyy' : 'EEEE, dd MMMM yyyy';
  const dateTimeFormat = i18n.language === 'en' ? 'MMM dd, yyyy' : 'dd MMM yyyy';
  return {
    fullDateTimeformat,
    dateTimeFormat,
  };
};

export default {
  today: () => {
    const now = new Date();
    return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  },
  isDateToday: (startDateTime) => {
    const todayDate = new Date();
    const startDate = new Date(startDateTime);
    return todayDate.getDate() === startDate.getDate();
  },
  isInTimeWindow: (startDateTime, endDateTime, windowStartSpanInMin = 0, windowEndSpanInMin = 0) => {
    const now = DateTime.now();
    const startDate = DateTime.fromISO(startDateTime).minus({ minutes: windowStartSpanInMin });
    const endDate = DateTime.fromISO(endDateTime).plus({ minutes: windowEndSpanInMin });
    return now > startDate && now < endDate;
  },
  isDateBeforeNow: (dateTime, windowSpanInMin = 0) => {
    const now = DateTime.now();
    const date = DateTime.fromISO(dateTime).minus({ minutes: windowSpanInMin });
    return now > date;
  },
  fullFormatDateTimeString: (text) => {
    if (text instanceof Date) return DateTime.fromJSDate(text).setLocale(i18n.language).toFormat(getFormat().fullDateTimeformat, { locale: i18n.language });
    if (typeof text === 'string') return DateTime.fromISO(text).setLocale(i18n.language).toFormat(getFormat().fullDateTimeformat, { locale: i18n.language });
    if (text instanceof DateTime) return text.setLocale(i18n.language).toFormat(getFormat().fullDateTimeformat, { locale: i18n.language });
    return '';
  },
  formatDateTimeString: (text) => {
    if (text instanceof Date) return DateTime.fromJSDate(text).toFormat(getFormat().dateTimeFormat, { locale: i18n.language });
    if (typeof text === 'string') return DateTime.fromISO(text).toFormat(getFormat().dateTimeFormat, { locale: i18n.language });
    return '';
  },
  formatTimeString: (text, timezone = null) => {
    let dt;
    if (text instanceof Date) dt = DateTime.fromJSDate(text);
    if (typeof text === 'string') dt = DateTime.fromISO(text);
    if (dt) {
      if (timezone) return dt.setZone(timezone).setLocale(i18n.language).toFormat('t');
      return dt.setLocale(i18n.language).toFormat('t');
    }
    return '';
  },
  isMoreThanHourDifference: (endDateTime, startDateTime) => {
    const timeDiffInMilliSeconds = Math.abs(DateTime.fromISO(endDateTime) - DateTime.fromISO(startDateTime)) / 1000;
    const timeDiffInHours = Math.floor(timeDiffInMilliSeconds / 3600) % 24;
    const isMoreThanHourDifference = timeDiffInHours >= 1;
    return isMoreThanHourDifference;
  },
};
